import template from './acris-edit-document-modal.html.twig';
import './acris-edit-document-modal.scss';

const { Component } = Shopware;

Component.register('acris-edit-document-modal', {
    template,

    inject: ['repositoryFactory'],

    emits: ['modal-close', 'modal-save'],

    props: {
        documentItem: {
            type: Object,
            required: true
        }
    },

    methods: {
        changeLanguageSelection(entityCollection) {
            this.documentItem.languages = entityCollection;
        },

        onCancel() {
            this.$emit('modal-close');
        },

        onApply() {
            this.$emit('modal-save', this.documentItem);
        }
    }
});
